'use strict';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import * as mapboxgl from 'mapbox-gl';
import MapboxCompare from 'mapbox-gl-compare';
import { LngLatBounds } from 'mapbox-gl';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ILabel } from '../shared/components/map/models/labels.interface';
import * as failures from '../../assets/failures.json';
import { default as patrones } from '../../assets/patrones.json';
import { default as presiones2 } from '../../assets/presiones_inyectors.json';
import * as turf from '@turf/turf';
import { IGraphData } from '../shared/components/map/models/graph-data.interface';
import { allGraphs, fillGraph } from '../shared/components/map/sidebar/models/graph-type.constants';

//import * as THREE from 'three';
import { PLYLoader } from '@loaders.gl/ply';
import { PointCloudLayer, SimpleMeshLayer, CompositeLayer } from 'deck.gl';
import { MapboxLayer } from '@deck.gl/mapbox';
import { CylinderGeometry } from '@luma.gl/core'
import { formatDate } from '@angular/common';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  public style = 'mapbox://styles/mapbox/dark-v11';
  public map!: mapboxgl.Map;
  public afterMap!: mapboxgl.Map;
  public compare!: MapboxCompare;
  public styleId: string = 'dark-v11';
  public showSearchZone: boolean = false;
  private stats: any;
  private renderer: any;
  public testing: any;
  public zoom: number = 10;
  currentPopup: mapboxgl.Popup | null = null;
  currentPopupCompare: mapboxgl.Popup | null = null;
  public coordenadas3d: any;
  public coordenadas3dCompare: any;
  public showCompare: boolean = false;
  public showRemoveCompare: boolean = false;
  private temporalSerieEvent = new BehaviorSubject<{ show: boolean, dmu: string }>({ show: false, dmu: '' });
  temporalSerie$: Observable<{ show: boolean, dmu: string }> = this.temporalSerieEvent.asObservable();
  popup: mapboxgl.Popup | null | undefined;
  toast!: HTMLIonToastElement;
  errors: any[] = [];

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private http: HttpClient,
    private toastController: ToastController
  ) { }

  public initMap() {
    this.map.addControl(new mapboxgl.NavigationControl({ showCompass: true, showZoom: false }));
    //this.map.addControl(this.addCompareButton);
    this.map.setProjection('globe');
    this.coordenadas3d = [];
    this.map.on('style.load', () => {
      let coords: string[] = Object.keys(this.coordenadas3d);
      if (coords.length > 0) {
        coords.forEach((layer) => {
          this.add3dConectividades(layer)
        });
      }
      this.map.setFog({
        'space-color': 'rgb(11, 11, 25)', // Background color        
      });
      this.getFaults();
      this.addPatrones();
    });
    this.map.on('dataloading', () => {
      window.dispatchEvent(new Event('resize'));
      // mapboxObj.resize(); also work
    });


    let lastCenter = this.afterMap.getCenter();
    this.map.on('moveend', () => {
      let newCenter = this.map.getCenter();
      if (
        newCenter.lng !== lastCenter.lng ||
        newCenter.lat !== lastCenter.lat
      ) {
        this.setShowSearchZone(true);
      }
      lastCenter = newCenter;
    });
  }

  public initMap2() {
    this.afterMap.setProjection('globe');
    //this.afterMap.addControl(this.addRemoveCompareButton);
    this.coordenadas3dCompare = [];
    let lastCenter = this.afterMap.getCenter();
    this.afterMap.on('moveend', () => {
      let newCenter = this.map.getCenter();
      if (
        newCenter.lng !== lastCenter.lng ||
        newCenter.lat !== lastCenter.lat
      ) {
        this.setShowSearchZone(true);
      }
      lastCenter = newCenter;
    });
    this.afterMap.on('dataloading', () => {
      window.dispatchEvent(new Event('resize'));
      // mapboxObj.resize(); also work
    });
  }

  createCompare() {
    if (this.showCompare == false) {
      this.afterMap.setCenter(this.map.getCenter());
      this.afterMap.setZoom(this.map.getZoom());
      this.afterMap.setPitch(this.map.getPitch());
      //this.afterMap.setStyle(this.map.getStyle().sprite?.toString() ?? "");      

      const container = '#comparison-container';
      this.compare = new MapboxCompare(this.map, this.afterMap, container, {
        // Set this to enable comparing two maps by mouse movement:
        //mousemove: true, 
        orientation: 'vertical'
      });
      this.showCompare = true;
      //this.compare.setSlider(window.outerWidth);
    }
  }

  removeAllLayer(compare: boolean = false) {
    let map = this.map;
    if(compare){
      map = this.afterMap;
    }
    allGraphs.forEach((type) => {
      const layers = map
        .getStyle()
        .layers.filter((layer) => layer.id.slice(0, (compare ? 'compare'.length : type.length)) == (compare ? 'compare' : type));          
      // Recorra la lista de capas y elimine cada una
      if (layers.length > 0) {
        layers.forEach((layer) => {
          map.removeLayer(layer.id);
        });
      }

      map.getStyle().sources &&
        Object.keys(map.getStyle().sources).forEach((sourceId) => {
          if (sourceId.slice(0, (compare ? 'compare'.length : type.length)) == (compare ? 'compare' : type)) {
            map.removeSource(sourceId);
          }
        });
    });
    this.removeAll3dModel(compare);
  }

  removeCompareLayers(idLayer) {
    let llaves = this.afterMap.getStyle().layers.filter((layer) => layer.id.includes(idLayer) && layer.id.includes('compare-'));
    llaves.forEach((layer) => {
      this.afterMap.removeLayer(layer.id);
      this.afterMap.removeSource(layer.id);
    });
  }

  addPatrones() {
    if (this.map.getLayer('patrones')) {
      this.map.removeLayer('patrones');
      this.map.removeSource('patrones');
    } else {
      const data = {
        type: 'FeatureCollection',
        features: patrones['features'].map((feature) => {
          return {
            type: feature.type,
            geometry: {
              coordinates: feature.coordinates,
              type: feature.type,
            },
          };
        }),
      };
      this.addGeoJsonToMap(data, 'patrones');
      this.setVisibilityLayer(false, 'patrones');
    }
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  addPresiones3() {
    if (this.map.getLayer('test1')) {
      this.map.removeLayer('test1');
      this.map.removeSource('test1');
    } else {
      presiones2['features'].forEach((feature) => {
        switch (feature.properties.type) {
          case 'alerta_fecha':
            //this.addGeoJsonToMap(feature, feature.properties.type, 'circle');
          break;
          case 'polygon_max_tvd':
            feature.properties['color'] = this.getRandomColor();
            feature.features = feature?.features?.map((element) => {
              return {
                ...element,
                properties: { ...element.properties, color: '#8F8F8F' },
              };
            });

            this.addGeoJsonToMap(feature, feature.properties.type, 'fill');
          break;
          case 'level':
            feature.features = feature?.features?.map((element) => {
              return {
                ...element,
                properties: { ...element.properties, color: '#1F1F1F' },
              };
            });
            this.addGeoJsonToMap(feature, feature.properties.type, 'fill');
          break;
          case 'graphs':
            feature.properties['color'] = '#000000';
            feature.properties['width'] = 3;
            this.addGeoJsonToMap(feature, feature.properties.type, 'line');
          break;
          case 'max_tvd':
            feature.features = feature?.features?.map((element) => {
              return {
                ...element,
                properties: {
                  ...element.properties,
                  color: element?.properties?.gp_bfpd_color,
                  radius: 8,
                  fill: true,
                  stroke_color: element?.properties?.level_color,
                },
              };
            });
            this.addCircleLayer(feature.features, 'max_tvd' + Math.random());
          break;
          case 'intake_tvd':
            feature.features = feature?.features?.map((element) => {
              return {
                ...element,
                properties: {
                  ...element.properties,
                  color: '#000000',
                  width: 4,
                },
              };
            });
            this.addGeoJsonToMap(feature, feature.properties.type, 'line');
          break;
        }
      });
    }
  }

  public addCircleLayer(circlesData, id, compare: boolean = false) {
    const combinedCircles: any = turf.featureCollection([]);

    for (const circleData of circlesData) {
      const options: any = { steps: 64, units: 'meters' };
      const circle: any = turf.circle(
        [
          circleData?.geometry.coordinates[0],
          circleData?.geometry.coordinates[1],
        ],
        circleData.properties.radius,
        options
      );

      const { color, value, graph_unit, fill, transparency } =
        circleData.properties;
      circle.properties = {
        ...circle.propertie,
        color,
        value,
        graph_unit,
        fill,
        transparency,
      };
      combinedCircles.features.push(circle);
    }

    const geojsonAgrupado = this.groupByFill(combinedCircles);
    for (const type in geojsonAgrupado) {
      if (geojsonAgrupado.hasOwnProperty(type)) {
        const featureCollection = geojsonAgrupado[type];
        const idLayer = compare ? 'compare-' + type + id : 'bubble' + id + type;
        let map = this.map;
        if(compare){
          map = this.afterMap;
          this.createCompare();
        }

        map.addSource(idLayer, {
          type: 'geojson',
          data: featureCollection,
        });
        map.addLayer({
          id: idLayer,
          type: type as any,
          source: idLayer,
          minzoom: 14,
          paint:
            type == 'fill'
              ? {
                'fill-color': [
                  'case',
                  ['has', 'color'],
                  ['get', 'color'],
                  'yellow',
                ],
                'fill-outline-color': [
                  'case',
                  ['has', 'stroke_color'],
                  ['get', 'stroke_color'],
                  '#e75504',
                ],
                'fill-opacity': [
                  'case',
                  ['has', 'transparency'],
                  ['/', ['get', 'transparency'], 100],
                  1,
                ],
              }
              : ({
                'line-color': ['get', 'color'],
                'line-width': 2,
              } as any),
        });
        map.on('mouseenter', idLayer, (e) => {
          if (this.popup) {
            this.popup.remove();
          }
          map.getCanvas().style.cursor = 'pointer';
          this.showTooltip(e, map, compare);
        });
        map.on('mouseleave', idLayer, () => {
          map.getCanvas().style.cursor = '';
          if (this.popup) {
            this.popup.remove();
            this.popup = null;
          }
        });
        

      }
    }
  }

  groupByFill(data: any) {
    return data.features.reduce((acumulador, feature) => {
      const fill = feature.properties.fill;

      // Si no existe un grupo para la categoría actual, créalo.
      if (!acumulador[fill ? 'fill' : 'line']) {
        acumulador[fill ? 'fill' : 'line'] = {
          type: 'FeatureCollection',
          features: [],
        };
      }

      // Agrega la feature al grupo correspondiente.
      acumulador[fill ? 'fill' : 'line'].features.push(feature);

      return acumulador;
    }, {});
  }

  public addGeoJsonToMap(geojson, id, type = 'line', compare = false) {
    id = id.toString();
    let map = this.map;
    if (compare) {
      map = this.afterMap;
      this.createCompare();
    }
    if (map.getLayer(id)) {
      map.removeLayer(id);
      map.removeSource(id);
    }

    map.addSource(id, {
      type: 'geojson',
      data: geojson,
    });
    let layer = {
      id: id,
      type: type as any,
      source: id,
      //minzoom: 14,
      paint:
        type == 'fill'
          ? {
            'fill-color': [
              'case',
              ['has', 'color'],
              ['get', 'color'],
              'gray',
            ],
            'fill-opacity': [
              'case',
              ['has', 'transparency'],
              ['/', ['get', 'transparency'], 100],
              1,
            ],
          }
          : type == 'line'
            ? ({
              'line-color': [
                'case',
                ['has', 'color'],
                ['get', 'color'],
                'gray',
              ],
              'line-width': ['case', ['has', 'width'], ['get', 'width'], 2],
            } as any)
            : {
              'circle-color': [
                'case',
                ['has', 'color'],
                ['get', 'color'],
                'gray',
              ],
              'circle-stroke-color': [
                'case',
                ['has', 'stroke_color'],
                ['get', 'stroke_color'],
                ['get', 'color'],
              ],
              'circle-stroke-width': [
                'case',
                ['has', 'stroke-width'],
                ['get', 'stroke-width'],
                2,
              ],
              'circle-radius': [
                'case',
                ['has', 'radius'],
                ['get', 'radius'],
                5,
              ],
            }
    }
    map.addLayer(layer);
    map.on('mouseenter', id, (e) => {
      if (this.popup) {
        this.popup.remove();
      }
      map.getCanvas().style.cursor = 'pointer';
      this.showTooltip(e, map, compare);
    });
    map.on('mouseout', id, (e) => {
      map.getCanvas().style.cursor = '';
      if (this.popup) {
        this.popup.remove();
        this.popup = null;
      }
    });
    if (map.getLayer('dmu')) {
      map.moveLayer(id, 'dmu');
    }    
  }

  private showTooltip(e, map, compare = false) {
    const value = e.features[0].properties.value;
    const graph_unit = e.features[0].properties.graph_unit;
    const date = e.features[0].properties.date;
    const texto = `<p>${graph_unit ? graph_unit + '<br>' : ''}  ${date ? date + '<br>' : ''} ${value ? parseFloat(value?.toFixed(4)) : ''}</p>`;
    this.popup = this.currentPopup;
    if(compare){
      this.popup = this.currentPopupCompare;
    }
    if (value || graph_unit) {
      this.popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      })
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML(texto)
        .addTo(map);
    }
    if (e.features[0].layer.id.includes('conectividad')) {
      this.popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      })
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML(
          `<p>
            <b>${e.features[0].properties.dmu + ' - ' + e.features[0].properties.dmu_k}</b><br>
            ${e.features[0].properties.text_color + ' - ' + e.features[0].properties.value_color}<br>
            ${e.features[0].properties.text_transparency + ' - ' + e.features[0].properties.value_transparency}<br>
            ${e.features[0].properties.text_width + ' - ' + e.features[0].properties.value_width}<br>
          </p>`
        )
        .addTo(map);
    }
  }


  getFaults() {
    this.map.addSource('Failures', {
      type: 'geojson',
      data: failures as any,
    });

    this.map.addLayer({
      id: 'failures',
      type: 'line',
      source: 'Failures',
      paint: {
        'line-color': ['get', 'color'],
        'line-width': 6,
      },
    });

    this.map.addLayer({
      id: 'metro-highlighted',
      type: 'line',
      source: 'Failures',
      paint: {
        'line-color': ['get', 'color'],
        'line-width': 10,
      },
      filter: ['in', 'OGC_FID', ''],
    });

    this.setVisibilityLayer(false, 'failures');

  }

  public switchStyle(layer: string) {
    if (this.styleId != layer) {
      this.styleId = layer;
      this.switchBaseMap(this.map, layer);
      this.switchBaseMap(this.afterMap, layer);
    }
  }

  private setShowSearchZone(value: boolean) {
    this.showSearchZone = value;
    this.ngZone.run(() => this.router.navigate(['/map']));
  }

  async switchBaseMap(map: any, styleID: string) {
    const response = await fetch(
      `https://api.mapbox.com/styles/v1/mapbox/${styleID}?optimize=true&access_token=${environment.MAPBOX_KEY}`
    );
    const responseJson = await response.json();
    const newStyle = responseJson;

    const currentStyle = map.getStyle();
    // ensure any sources from the current style are copied across to the new style
    newStyle.sources = Object.assign({},
      currentStyle.sources,
      newStyle.sources
    );
    // find the index of where to insert our layers to retain in the new style
    let labelIndex = newStyle.layers.findIndex((el) => {
      return el.id == 'waterway-label';
    });
    // default to on top
    if (labelIndex === -1) {
      labelIndex = newStyle.layers.length;
    }
    const appLayers = currentStyle.layers.filter((el) => {
      // app layers are the layers to retain, and these are any layers which have a different source set
      return (
        el.source &&
        el.source != 'mapbox://mapbox.satellite' &&
        el.source != 'mapbox' &&
        el.source != 'composite'
      );
    });
    newStyle.layers = [
      ...newStyle.layers.slice(0, labelIndex),
      ...appLayers,
      ...newStyle.layers.slice(labelIndex, -1),
    ];
    map.setStyle(newStyle);
    //this.map.setStyle(newStyle);
  }

  getDataLabelByBounds(bounds: LngLatBounds): Observable<ILabel[]> {
    const southwest = bounds.getSouthWest();
    const northeast = bounds.getNorthEast();
    return this.http.get<ILabel[]>(
      `${environment.url}/data/label?in_bbox=${northeast.lng},${northeast.lat},${southwest.lng},${southwest.lat}`
    );
  }

  getTreeLabelByBounds(bounds: LngLatBounds): Observable<ILabel[]> {
    const southwest = bounds.getSouthWest();
    const northeast = bounds.getNorthEast();
    return this.http.get<ILabel[]>(
      `${environment.url}/data/category?in_bbox=${northeast.lng},${northeast.lat},${southwest.lng},${southwest.lat}`
    );
  }

  addGeoJson(data: any[], compare: boolean = false) {
    let errors:any[] = []
    data.forEach((element) => {
      if(element?.data?.features?.length > 0  && element?.data ){
        if (element.type == 'bubble') {
          element?.data &&
            this.addCircleLayer(element.data, element.id, compare);
        } else {
          const type = fillGraph.includes(element.type) ? 'fill' : 'line';
          this.addGeoJsonToMap(element.data, compare ? 'compare-' + element.type + element.id : element.type + element.id, type, compare);
        }
      }else{
        this.errors.push(element.name)
      }
    });
    
  }

  async presentToast(message: string) {
    this.toast = await this.toastController.create({
      message: message,
      color: 'warning',
      position: 'bottom',
      duration: 4000
      
    });
    this.toast.present();
  }

  addDonut(data: any[], compare: boolean = false) {
    let map = this.map;
    if(compare){
      map = this.afterMap;
    }
    let errors:any[] = []
    data.forEach((donut) => {
      if(!donut?.data || (donut?.data?.err && donut.data.err.trim() !== '') || Object.keys(donut.data).length === 0){
        this.errors.push(donut.name);
      }else {
      const features: any[] = donut.data.map((e) => e.features).flat();
      let dividedChunks: any[] = [];
      const chunkSize = 100;

      for (let i = 0; i < features.length; i += chunkSize) {
        const chunk = features.slice(i, i + chunkSize);
        dividedChunks.push(chunk);
      }

      dividedChunks.forEach((element, index) => {
        const id = compare ? 'compare-donut' + index + '-' + donut.id : 'donut' + index + '-' + donut.id;
        let source = {
          type: 'FeatureCollection',
          features: element,
        };
        map.addSource(id, {
          type: 'geojson',
          data: source as any,
        });

        map.addLayer({
          id,
          type: 'line', // Set layer type to 'line'
          source: id,
          paint: {
            'line-color': ['get', 'color'], // Set line color to the segment color
            'line-width': ['get', 'width'], // Adjust line width as needed
          },
        });

        const popup = new mapboxgl.Popup({
          closeButton: false, // Opcional: si deseas un botón de cierre
        });

        map.on('mouseenter', id, (e: any) => {
          // Cambia el cursor al estilo de un puntero cuando el usuario se coloca sobre la capa.
          map.getCanvas().style.cursor = 'pointer';
          // Establece el contenido del tooltip.
          popup
            .setLngLat([e.lngLat.lng, e.lngLat.lat])
            .setHTML(
              `<strong>${e.features[0]?.properties?.dmu} </strong> -  ${e.features[0]?.properties?.name
              }  -  ${parseFloat(
                e.features[0]?.properties?.percentage.toFixed(4)
              )} %`
            )
            .addTo(map);
              
        });
      
        map.on('mouseleave', id, () => {
          // Restablece el cursor al valor predeterminado cuando el usuario sale de la capa.
          this.map.getCanvas().style.cursor = '';
          popup.remove();
        });
        
      });
  
    
      }
    });
  }

  addImage(graphDataList: any[], compare: boolean = false) {
    for (let graphData of graphDataList) {

      if (graphData?.data?.image) {
        const id = compare ? 'compare-' + `${graphData.id}` : `${graphData.type}-${graphData.id}`;
        let map = this.map;
        if(compare){
          map = this.afterMap;
          this.createCompare();
        }
        map.addLayer({
          id,
          type: 'raster',
          source: {
            type: 'image',
            url: graphData.data.image,
            coordinates: [
              [
                graphData.data.corner_2.longitude,
                graphData.data.corner_1.latitude,
              ],
              [
                graphData.data.corner_1.longitude,
                graphData.data.corner_1.latitude,
              ],
              [
                graphData.data.corner_1.longitude,
                graphData.data.corner_2.latitude,
              ],
              [
                graphData.data.corner_2.longitude,
                graphData.data.corner_2.latitude,
              ],
            ],
          },
          paint: {
            'raster-fade-duration': 0,
            //'raster-opacity': 0.75,
          },
        });
        map.moveLayer(id, 'dmu');
      }else{
        this.errors.push(graphData.name)
      }
    }
  }

  removeAll3dModel(compare: boolean = false) {
    let coords: string[] = Object.keys(this.coordenadas3d);
    let map = this.map;
    if(compare){
      coords = Object.keys(this.coordenadas3dCompare);
      map = this.afterMap;
    }
    if (coords.length > 0) {
      coords.forEach((layer) => {
        if (map.getLayer('3d-model-' + layer)) {
          map.removeLayer('3d-model-' + layer);
        }
      });
      if(compare){
        this.coordenadas3dCompare = [];        
      }else{
        this.coordenadas3d = [];        
      }      
    }
    if(this.popup){
      this.popup.remove();
      this.popup = null;
    }
  }

  public setVisibilityLayer(show: boolean, layerId: string = '3d-model') {
    show
      ? this.map.setLayoutProperty(layerId, 'visibility', 'visible')
      : this.map.setLayoutProperty(layerId, 'visibility', 'none');
  }

  public setCenterMap(lat: number, lng: number, zoom = 10, changePitch: boolean = false) {
    this.map.easeTo({
      center: [lng, lat],
      zoom: zoom,
      duration: 1000,
      pitch: changePitch ? 60 : this.map.getPitch()
    });
  }

  get zoomLevel() {
    return this.map.getZoom();
  }

  getDmus(wellData: any, map) {
    if (map.getLayer('dmu')) {
      map.removeLayer('dmu');
      map.removeLayer('cluster-count');
      map.removeLayer('unclustered-point');
    }
    if (map.getSource('dmu-data')) {
      map.removeSource('dmu-data');
    }

    let test: any[] = [];
    let dmuPointJson: any = {
      type: 'FeatureCollection',
      features: test,
    };
    for (let well of wellData) {
      let dmuObject = {
        type: 'Feature',
        geometry: {
          coordinates: [well.lon, well.lat],
          type: 'Point',
        },
        properties: {
          name: '',
          color: '#BE0BE3'
        },
      };
      if (well.name) {
        dmuObject.properties.name = well.name;
      }

      dmuPointJson.features.push(dmuObject);
    }
    map.addSource('dmu-data', {
      type: 'geojson',
      data: dmuPointJson,
      cluster: true,
      clusterMaxZoom: 12,
      clusterRadius: 25,
    });
    map.addLayer({
      id: 'dmu',
      type: 'circle',
      source: 'dmu-data',
      filter: ['has', 'point_count'],
      paint: {
        //'circle-color': '#BE0BE3',
        //'circle-radius': 5,
        'circle-color': [
          'step',
          ['get', 'point_count'],
          '#3a5f0a',
          100,
          '#3a5f0a',
          750,
          '#3a5f0a',
        ],
        'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
        'circle-stroke-width': 3,
        'circle-stroke-color': '#3a5f0a',
        'circle-opacity': 0.5,
      },
    });
    map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'dmu-data',
      filter: ['has', 'point_count'],
      paint: {
        'text-color': '#ffffff',
      },
      layout: {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      },
    });
    map.on('click', 'dmu', (e: any) => {
      const features: any = map.queryRenderedFeatures(e.point, {
        layers: ['dmu'],
      });
      const clusterId = features[0].properties.cluster_id;

      const source = map.getSource('dmu-data') as mapboxgl.GeoJSONSource;
      source.getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err) return;
        map.easeTo({
          center: features[0].geometry.coordinates,
          zoom: zoom,
        });
      });
    });
    map.on('click', 'unclustered-point', (e: any) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const description = e.features[0].properties.name;
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      new mapboxgl.Popup({
        closeButton: false,
      })
        .setLngLat(coordinates)
        .setText(description)
        .addTo(map);
    });

    let currentPopup: mapboxgl.Popup | null = null;
    map.on('contextmenu', 'unclustered-point', (e: any) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const description = e.features[0].properties.name;
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      if (currentPopup) {
        currentPopup.remove();
      }

      // Crear un contenedor div para el contenido HTML con opciones
      const container = document.createElement('div');

      // Agregar opciones al contenedor
      container.innerHTML = `
        <div style="cursor: pointer">Ver series temporales </div>
      `;


      // Agregar evento de clic a cada opción
      container.querySelectorAll('div').forEach((option, index) => {
        option.addEventListener('click', () => {
          // Manejar el clic en la opción (puedes personalizar esto según tus necesidades)

          if (index == 0) {
            this.temporalSerieEvent.next({ show: true, dmu: description });
            if (currentPopup) {
              currentPopup.remove();
            }
          } else {
            alert(`Opción ${index + 1} clickeada`);
          }
        });
      });

      currentPopup = new mapboxgl.Popup({
        closeButton: false,
      })
        .setLngLat(coordinates)
        .setDOMContent(container) // Utilizar setDOMContent en lugar de setHTML
        .addTo(map);
    });
    map.addLayer({
      id: 'unclustered-point',
      type: 'circle',
      source: 'dmu-data',
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-color': ['get', 'color'],
        'circle-radius': 5,
        'circle-stroke-width': 3,
        'circle-stroke-color': ['get', 'color'],
      },
    });

    map.on('mouseenter', 'dmu', (e: any) => {
      map.getCanvas().style.cursor = 'pointer';
    });

    map.on('mouseleave', 'dmu', () => {
      map.getCanvas().style.cursor = '';
    });
    this.setVisibilityLayer(true, 'dmu');
  }

  public getCordinates() {
    return this.http.get<mapboxgl.LngLat[]>('assets/coordenadas.json');
  }

  getHTML(text: string, index: number) {
    return `<div >
      <span  style="display: flex;flex-direction: row;align-content: center;"> 
      
        <span  class="texto-visible-${index}">${text}</span>
      </span>
    </div>`;
  }

  add3dgraph(data: any[], compare: boolean = false) {
    data.forEach((element) => {
      if (element?.data?.length > 0 && element?.data) {
        let id = element.variable + '-' + element.id;
        if (compare) {
          this.coordenadas3dCompare[id] = element.data;
        } else {
          this.coordenadas3d[id] = element.data;
        }
        this.add3dConectividades(id, compare);
      }else{
        this.errors.push(element.name)
      }
    });
  }

  addALert3d(url, id, origin, datos) {
    this.map.setPitch(60)
    if (this.map.getLayer('3d-alert')) {
      this.map.removeLayer('3d-alert');
    }
    let color = [255, 255, 0];
    let height = 0;
    if (datos.model_setting_color) {
      color = this.hex2rgba(datos.model_setting_color);
    }
    if (datos.model_setting_z) {
      height = parseInt(datos.model_setting_z);
    }
    let points_cloud = new MapboxLayer({
      id: '3d-alert',
      data: origin,
      type: SimpleMeshLayer,
      mesh: url,
      getColor: color,
      getOrientation: d => [0, 0, 90],
      getTranslation: d => { return [0, 0, height]; },//Cambiar posicion de barras (metros)
      getPosition: d => {
        return [parseFloat(d["lon"]), parseFloat(d["lat"])];
      },
      onClick: (d) => {
        if (this.popup) {
          this.popup.remove();
        }
        this.map.getCanvas().style.cursor = 'pointer';
        this.showAlertTooltip(d, "alertas", this.map);
      },
      pickable: true,
      loaders: [PLYLoader],
      sizeScale: 1,
    })
    this.map.addLayer(points_cloud);
    this.setVisibilityLayer(true, '3d-alert');
  }

  private showAlertTooltip(e, tipo, map, compare: boolean = false) {
    this.popup = this.currentPopup;
    if(compare){
      this.popup = this.currentPopupCompare;
    }
    if (e) {
      if (tipo.includes("alertas")) {
        this.popup = new mapboxgl.Popup({
          closeButton: true,
          closeOnClick: false,
          offset: 25,
          className: 'alert-popup'
        })
          .setLngLat(e.object)
          .setHTML("<p><b>" + e.object.alert_type_name + "<br>" + e.object.name + ": " + e.object.dmu_name + "</b><br>" + formatDate(e.object.date, 'dd/MM/yy, h:mm a', 'en-US') + "</p><p>" + e.object.description + "</p>")
          .addTo(map);
      }
      if (tipo.includes("normal")) {
        if (e.object.dmu) {
          this.popup = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: false,
            offset: 25,
            className: 'alert-popup'
          })
          .setLngLat(e.object)
          .setHTML(
            `<p>
              <b>${e.object.dmu + ' - ' + e.object.dmu_k}</b><br>
              ${e.object.text_color + ': ' + e.object.value_color}<br>
              ${e.object.text_transparency + ': ' + e.object.value_transparency}<br>
              ${e.object.text_width + ': ' + e.object.value_width}<br>
            </p>`
          )
          .addTo(map);          
        } else if (e.object.height_text) {
          this.popup = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: false,
            offset: 25,
            className: 'alert-popup'
          })
          .setLngLat(e.object)
          .setHTML(
            `<p><b>${e.object.height_text}:</b> ${e.object.value}<br></p>`
          ).addTo(map);          
        }
      }
    }
  }

  addbuildings() {
    if (this.map.getSource('dmu-data')) {
      this.map.addLayer({
        'id': 'extrusion',
        'type': 'fill-extrusion',
        "source": {
          "type": "geojson",
          "data": {
            "type": "FeatureCollection",
            "features": []
          }
        },
        'paint': {
          'fill-extrusion-color': '#00f',
          'fill-extrusion-height': 100,
          'fill-extrusion-base': 0,
          'fill-extrusion-opacity': 0.9
        }
      });

      this.map.on('sourcedata', (e: any) => {
        if (e.sourceId !== 'dmu-data') return
        if (e.isSourceLoaded !== true) return

        let data: any = {
          "type": "FeatureCollection",
          "features": []
        }
        e.source.data.features.forEach((f: any) => {
          let object = turf.centerOfMass(f)
          let center = object.geometry.coordinates
          let radius = 15;
          let crcle: any = turf.circle(center, radius, {
            steps: 5,
            units: 'meters'
          });
          data.features.push(crcle)
        })
        if (this.map.getSource('extrusion')) {
          let ext = this.map.getSource('extrusion');
          (ext as mapboxgl.GeoJSONSource).setData(data);
        }

      })
    }
  }

  add3dConectividades(variable, compare: boolean = false) {
    let map = this.map;
    let coords = this.coordenadas3d;
    if (compare) {
      map = this.afterMap;
      coords = this.coordenadas3dCompare;
      this.createCompare();
    }
    if (map.getSource('3d-model-' + variable)) {
      console.log("Existe el recurso ");
    }
    if (map.getLayer('3d-model-' + variable)) {
      map.removeLayer('3d-model-' + variable);
    }
      
    let points_cloud = new MapboxLayer({
      id: '3d-model-' + variable,
      data: coords[variable],
      type: SimpleMeshLayer,
      onClick: (d) => {
        if (this.popup) {
          this.popup.remove();
        }
        map.getCanvas().style.cursor = 'pointer';
        this.showAlertTooltip(d, "normal", map, compare);
      },
      // Get the color by pipe
      getColor: d => this.hex2rgba(d.color),
      // Get the orientation by pipe
      getOrientation: d => {
        let x = 0;
        let y = 0;
        let z = 0;
        if (d.height) z = 90;
        if (d.angle) y = d.angle;
        return [x, y, z];
      },
      // Translate pipe to the center
      getTranslation: d => {
        let height = 0;
        if (d.height) height = d.height / 2;
        else height = 50;
        return [0, 0, height];
      },
      // Get the position of the pipe
      getPosition: d => {
        return [d.lon, d.lat]
      },
      // Init the cylinder mesh with the radius and height
      mesh: new CylinderGeometry({
        radius: 10,
        height: 1, //(Metros)
      }),
      // Get the scale of the pipe, the scale on Y is given by the distance
      getScale: d => {
        let dist = 0;
        if (d.distance) dist = d.distance;
        else dist = d.height;
        return [1, dist, 1]
      },
      pickable: true,
    });
    map.addLayer(points_cloud);
    
  }

  hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return [r, g, b];
  }

  invertColor(hex) {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    // invert color components
    let r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
      g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
      b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
  }

  padZero(str, len = 2) {
    len = len || 2;
    let zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }

  addCompareButton = {
    onAdd: (map: any) => {
      const div = document.createElement("div");
      div.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      div.innerHTML = `<ion-button id="open-modal" color="secondary" *ngIf="showCompare">Comparar</ion-button>`;
      div.addEventListener("contextmenu", (e) => e.preventDefault());
      /* div.addEventListener("click", () => {
        if(!this.showCompare){
          this.createCompare();
        }else{
          this.compare.remove();
          this.showCompare = false;
        }        
      }); */

      return div;
    },
    getDefaultPosition: () => {
      return 'top-right'
    },
    onRemove: () => {
    }
  }

  addRemoveCompareButton = {
    onAdd: (map: any) => {
      const div = document.createElement("div");
      div.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      div.innerHTML = `<ion-button color="secondary" >Remover</ion-button>`;
      div.addEventListener("contextmenu", (e) => e.preventDefault());
      div.addEventListener("click", () => {
        this.compare.remove();
        this.showCompare = false;
        this.removeAll3dModel(true)

      });

      return div;
    },
    getDefaultPosition: () => {
      return 'top-right'
    },
    onRemove: () => { }
  }


}